import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Skull } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sid) { navigate("/login"); return; }
      try {
        const u = await api.googleSession(sid);
        setUser(u);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 dark">
      <Skull className="h-10 w-10 text-primary animate-pulse" />
      <div className="font-mono text-sm text-muted-foreground">Authentification en cours…</div>
    </div>
  );
}
